export function clientLabel(client, agent) {
  if (!client) return '';
  if (agent) {
    return `${agent.tls_code} — ${agent.full_name} — ${client.full_name}`;
  }
  return `Direct — ${client.full_name}`;
}

// Strips the "TLS-XX-" agent prefix off a client_code, leaving just the nickname.
// Used wherever the agent's tls_code is already shown separately, to avoid repeating it.
export function nicknameOnly(code) {
  if (!code) return '';
  return code.replace(/^\s*TLS\s*[-/]?\s*[0-9]*\s*[-/]?\s*/i, '').trim();
}
